// timestamp for limiting update impact validity, impacts before this ts are not relevant
export const UPDATE_IMPACTS_SINCE = new Date(Date.UTC(2017, 10)).getTime()

// timestamp for limiting analysis data validity, data for impacts before this ts are not relevant
export const UPDATE_IMPACT_ANALYSIS_DATA_SINCE = new Date(Date.UTC(2017, 1)).getTime()
